import { Outlet } from "react-router-dom";
import ReportModals from "./modals/ReportModals";
import ReportsSidePanel from "./sidepanel/ReportsSidePanel";

const ReportLayout = () => {
  return (
    <>
      <div className="row align-items-stretch no-gutters">
        <ReportsSidePanel />

        <section id="main-content" className="column" tabIndex={-1}>
          <Outlet />
        </section>
      </div>
      <ReportModals />
    </>
  );
};

export default ReportLayout;
